import { type CurrentUser } from '@repo/api-client';

/**
 * Domain layer — pure TypeScript, no React/HTTP/storage import (lint enforces it).
 *
 * Types come from `@repo/api-client`; rules live here.
 */

/** Several screens (Library, Activity) behave differently outside a household. */
export const belongsToFamily = (user: CurrentUser): boolean =>
  user.familyId !== null;

/** Display label, falling back from username to email. */
export function displayNameOf(user: CurrentUser): string {
  return (
    user.displayName.trim() ||
    user.username.trim() ||
    user.email?.split('@')[0] ||
    'Joueur'
  );
}

/** Initials for the fallback avatar — "Marie Dupont" -> "MD". */
export function initialsOf(user: CurrentUser): string {
  const name = displayNameOf(user);
  const parts = name.split(/\s+/).filter(Boolean);
  return parts.length > 1
    ? `${parts[0][0]}${parts[1][0]}`.toUpperCase()
    : name.slice(0, 2).toUpperCase();
}
